import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { PageTitle, Card } from "./AdminUI";

const TYPE = { contact: "Contatto", property: "Proposta immobile", investor: "Investitore", book_preview: "Anteprima libro", book_order: "Ordine libro", operation: "Dossier operazione" };

export default function Dashboard() {
  const { data } = useQuery({ queryKey: ["admin-stats"], queryFn: () => api.get("/admin/stats").then((r) => r.data) });
  const stats = [
    { label: "Progetti", value: data?.projects, to: "/admin/progetti" },
    { label: "Operazioni", value: data?.operations, to: "/admin/operazioni" },
    { label: "Richieste totali", value: data?.leads, to: "/admin/richieste" },
    { label: "Da leggere", value: data?.leads_unread, to: "/admin/richieste", accent: true },
  ];
  return (
    <div data-testid="admin-dashboard">
      <PageTitle title="Dashboard" subtitle="Panoramica del sito Home Haven" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((s) => (
          <Link key={s.label} to={s.to} data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}>
            <Card className="hover:border-gold transition-colors">
              <div className="text-xs uppercase tracking-[0.15em] text-stone">{s.label}</div>
              <div className={`font-serif text-4xl font-light mt-2 ${s.accent ? "text-gold" : "text-ink"}`}>{s.value ?? "—"}</div>
            </Card>
          </Link>
        ))}
      </div>
      <Card className="mt-8">
        <div className="flex items-center justify-between mb-4"><h2 className="text-sm font-medium">Ultime richieste</h2><Link to="/admin/richieste" className="text-xs text-stone hover:text-gold">Vedi tutte</Link></div>
        <div className="divide-y divide-gray-100">
          {(data?.recent_leads || []).map((l) => (
            <div key={l.id} className="py-3 flex items-center justify-between gap-4 text-sm">
              <div className="flex items-center gap-3">{!l.read && <span className="w-2 h-2 rounded-full bg-gold" />}<span className="font-medium">{l.name}</span><span className="text-stone">{TYPE[l.type]}</span></div>
              <span className="text-xs text-stone">{new Date(l.created_at).toLocaleDateString("it-IT")}</span>
            </div>
          ))}
          {data && data.recent_leads.length === 0 && <p className="text-sm text-stone py-3">Nessuna richiesta ricevuta.</p>}
        </div>
      </Card>
    </div>
  );
}
